import { CalendarDays } from 'lucide-react'
import { Select } from '@components/formFields/select'
import { DATE_FILTER_OPTIONS, useFilters } from './hooks/useFilters'

export function DateFilter() {
  const { numberOfDaysToFilter, setFilter } = useFilters()

  return (
    <Select
      name="Filter by Date"
      popoverId="select-folder"
      data={DATE_FILTER_OPTIONS}
      icon={<CalendarDays color="hsla(194, 47%, 20%, 1)" size={14} />}
      hideSearch
      selectedItems={numberOfDaysToFilter ? [Number(numberOfDaysToFilter)] : []}
      compact
      popoverDelay={0}
      clearable={false}
      multi={false}
      onClearCallback={() => {
        setFilter({ filteredDays: null })
      }}
      onSelectCallback={value => {
        setFilter({ filteredDays: value })
      }}
    >
      <>
        {DATE_FILTER_OPTIONS.map((filter, index) => {
          return (
            <Select.Option key={filter.id} id={filter.id} index={index}>
              <div className="flex gap-2">
                <CalendarDays color="hsla(194, 47%, 20%, 1)" size={14} />
                <p>{filter.name}</p>
              </div>
            </Select.Option>
          )
        })}
      </>
    </Select>
  )
}
